<template>
  <a-breadcrumb separator=">" class="bread-crumb">
    <a-breadcrumb-item>
      <router-link :to="{ name: routeName}">{{ goPathName }}</router-link>
    </a-breadcrumb-item>
    <a-breadcrumb-item v-if="cneterName">{{ cneterName }}</a-breadcrumb-item>
    <a-breadcrumb-item>{{ toName }}</a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    routeName: {
      type: String,
      default: ''
    },
    toName: {
      type: String,
      default: ''
    },
    goPathName: {
      type: String,
      default: ''
    },
    cneterName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style scoped lang="less">
.bread-crumb {
  height: 40px;
  line-height: 40px;
  background-color: #FFFFFF;
  padding-left: 20px;
  font-weight: bold;
  font-size: 18px;
}

.bread-crumb a {
  color: #FAAD14;
}
</style>